import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgParking = function SvgParking(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.2 0h17.6A3.2 3.2 0 0124 3.2v17.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 20.8V3.2A3.2 3.2 0 013.2 0zm3.2 4v16.24h3.41v-5.591h2.506c3.364 0 6.287-1.508 6.287-5.336 0-3.805-2.9-5.313-6.287-5.313H6.4zm5.986 7.68H9.81V6.945h2.576c1.252 0 2.621.604 2.621 2.367 0 1.786-1.369 2.366-2.621 2.366z",
    clipRule: "evenodd"
  }));
};

export default SvgParking;